import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, tap } from 'rxjs';
import { User, UserService } from './user-service';

@Injectable({ providedIn: 'root' })
export class AuthStateService {
  private userSubject = new BehaviorSubject<User | null>(null);

  user$ = this.userSubject.asObservable();

  constructor(private userService: UserService) {}

  loadUserIfNeeded(): Observable<User> {
    const current = this.userSubject.value;

    if (current) {
      return of(current);
    }

    return this.userService.getCurrentUser().pipe(
      tap(user => this.userSubject.next(user))
    );
  }

  get user(): User | null {
    return this.userSubject.value;
  }

  get roles(): string[] {
    return this.user?.roles ?? [];
  }

  hasRole(role: string): boolean {
    return this.roles.includes(role);
  }

  hasAnyRole(expectedRoles: string[]): boolean {
    return expectedRoles.some(role => this.roles.includes(role));
  }

  clear(): void {
    this.userSubject.next(null);
    this.userService.clearCache();
  }
}